/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type { CreditLine, CreditLineInterface } from "../CreditLine";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OWNER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PAUSER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "__BaseUpgradeablePausable__init",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "__PauserPausable__init",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "balance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "borrower",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "config",
    outputs: [
      {
        internalType: "contract GoldfinchConfig",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "currentLimit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "drawdown",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_config",
        type: "address",
      },
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_maxLimit",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_interestApr",
        type: "uint256",
      },
      {
        internalType: "contract ISchedule",
        name: "_schedule",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_lateFeeApr",
        type: "uint256",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "interestAccrued",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "interestAccruedAsOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "interestAccruedAt",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "interestApr",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "interestOwed",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "interestOwedAt",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isAdmin",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isLate",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "lastFullPaymentTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "lateFeeApr",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "limit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxLimit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nextDueTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "nextDueTimeAt",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "paymentAmount",
        type: "uint256",
      },
    ],
    name: "pay",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "owedInterestPayment",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "accruedInterestPayment",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "principalPayment",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "additionalBalancePayment",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "paymentRemaining",
            type: "uint256",
          },
        ],
        internalType: "struct ILoan.PaymentAllocation",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "principalPayment",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "interestPayment",
        type: "uint256",
      },
    ],
    name: "pay",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "owedInterestPayment",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "accruedInterestPayment",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "principalPayment",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "additionalBalancePayment",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "paymentRemaining",
            type: "uint256",
          },
        ],
        internalType: "struct ILoan.PaymentAllocation",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "principalOwed",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "principalOwedAt",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "schedule",
    outputs: [
      {
        internalType: "contract ISchedule",
        name: "schedule",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "startTime",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newAmount",
        type: "uint256",
      },
    ],
    name: "setLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newAmount",
        type: "uint256",
      },
    ],
    name: "setMaxLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "termEndTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "termStartTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalInterestAccrued",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "totalInterestAccruedAt",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalInterestOwed",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "totalInterestOwedAt",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalInterestPaid",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalPrincipalOwed",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "totalPrincipalOwedAt",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalPrincipalPaid",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withinPrincipalGracePeriod",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type CreditLineConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: CreditLineConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class CreditLine__factory extends ContractFactory {
  constructor(...args: CreditLineConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<CreditLine> {
    return super.deploy(overrides || {}) as Promise<CreditLine>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): CreditLine {
    return super.attach(address) as CreditLine;
  }
  override connect(signer: Signer): CreditLine__factory {
    return super.connect(signer) as CreditLine__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): CreditLineInterface {
    return new utils.Interface(_abi) as CreditLineInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): CreditLine {
    return new Contract(address, _abi, signerOrProvider) as CreditLine;
  }
}
